import { AddressGroupResponseItem, AddressGroupResponseList } from '@/types/service-response'

export class AddressGroup {
  public constructor (
    readonly id: number,
    readonly name: string,
    readonly addressCount: number | undefined
  ) {}

  static createFromResponse (responseData: AddressGroupResponseList): Array<AddressGroup> {
    let result: Array<AddressGroup> = []
    if (responseData) {
      result = responseData.map((address: AddressGroupResponseItem ) => {
        return new AddressGroup(
          address.ID,
          address.Bezeichnung,
          address.Adressen_count ? address.Adressen_count : undefined
        )
      })
    }
    return result
  }
}
